import { type MCPServerInfo } from '../../types';

const StatsigServer: MCPServerInfo = {
  serverId: 'STATSIG',
  name: 'Statsig',
  slug: 'statsig',
  description:
    'Statsig MCP Server - Access feature flags (gates), A/B experiments, dynamic configs, metrics, segments, and audit logs. Manage your Statsig project from AI tools like Cursor and Claude.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.statsig.com/v1/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default StatsigServer;
